import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogClose } from "../ui/dialog";
import { Button } from "../ui/button";

interface DeleteQualificationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  title?: string;
}

export const DeleteQualificationDialog: React.FC<DeleteQualificationDialogProps> = ({
  open,
  onOpenChange,
  onConfirm,
  title = "Archive Qualification"
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <div className="py-4 space-y-3">
          <p className="text-sm text-slate-600 leading-relaxed">
            Are you sure you want to delete this qualification? The record will be moved to the <span className="font-semibold text-slate-900">Recycle Bin</span> and can be restored for up to <span className="font-semibold text-slate-900">180 days</span>.
          </p>
          <p className="text-sm text-slate-400 italic">
            After 180 days, the record will be permanently purged from the system.
          </p>
        </div>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">Cancel</Button>
          </DialogClose>
          <Button 
            variant="destructive" 
            onClick={onConfirm}
            className="shadow-sm font-bold"
          >
            Confirm Deletion
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
